import { ComponentChildren, FunctionComponent } from 'preact';
import { Children } from 'preact/compat';
import { isElementOfType, wrapWithComponent } from 'utilities/components';

import { Item } from './components/Item';
import { Row } from './components/Row';

import styles from './FormLayout.module.scss';

interface FormLayoutProps {
  children: ComponentChildren;
}

export const FormLayout = function FormLayout({ children }: FormLayoutProps) {
  const itemsMarkup = Children.toArray(children).map((child, index) =>
    isElementOfType(child, Row)
      ? child
      : wrapWithComponent(child, Item, {
          key: index,
        }),
  );

  return <div className={styles.FormLayout}>{itemsMarkup}</div>;
} as FunctionComponent<FormLayoutProps> & {
  Row: typeof Row;
};

FormLayout.Row = Row;
